import { Debug, isDebugActive, getShowErrorComponent, webVitalsLog } from '@portal-internet/components';
export { Debug as default, isDebugActive, getShowErrorComponent, webVitalsLog };
